import React from 'react';
import Slider from 'Components/Slider';
import Checkbox from 'Components/Checkbox';
import Select from 'Components/Select';
import { SINGLE } from 'constants/boatApplication';
import { DIESEL_POWER_TYPE } from 'constants/boatApplication';

export default ({
  dieselPower,
  motorType,
  toggleMotorType,
  hasElectricPropulsion,
  toggleHasElectricPropulsion,
  dieselPowerCode,
  handleDieselToggle,
  handleDieselTypeChose,
  isError,
}) => {
  const getDefaultDieselPowerCode = () => {
    return dieselPowerCode ? dieselPowerCode[0].toUpperCase() + dieselPowerCode.slice(1).toLowerCase() : '';
  };

  if (motorType !== undefined) {
    return (
      <section className='scene_section motor-specification-section'>
        <header>Motor Specifications</header>
        <Slider
          state={motorType === SINGLE}
          mainWrapperClassName='green'
          label='Motor Type'
          onLabel='Single'
          offLabel='Twin'
          toggleAction={toggleMotorType}
        />
        <Slider
          state={!hasElectricPropulsion}
          mainWrapperClassName='green'
          label='Electric Propulsion'
          onLabel='No'
          offLabel='Yes'
          toggleAction={toggleHasElectricPropulsion}
        />
      </section>
    );
  }
  if (dieselPower !== undefined) {
    return (
      <section className='scene_section  fuel-type-section'>
        <header>Fuel Type</header>
        <Checkbox value={dieselPower} label='Diesel Power' onChange={handleDieselToggle} />
        <Select
          selectionList={DIESEL_POWER_TYPE}
          mainWrapperClassName='_width_330'
          inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
          dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
          defaultItem={getDefaultDieselPowerCode()}
          label='Diesel Power Type'
          disabled={!dieselPower}
          handleSelect={handleDieselTypeChose}
          error={isError('dieselPowerCode')}
        />
      </section>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/BoatSpecifications/AdditionalSection.jsx